import React from "react";
import styles from "./Passion.module.css";
import classNames from "classnames";

export const PassionSkeleton = () => {

  return <figure className={styles.card}>
    <div className={classNames(styles.image, styles.skeleton)} />
    <figcaption className={styles.caption}>
      <span className={classNames(styles.skeleton, styles.text)}></span>
      =
      <span className={classNames(styles.skeleton, styles.text)}></span>
    </figcaption>
  </figure>;
}